import AddNewInline from "./modules/add-new-inline";
import { initAcServices } from "AC/helpers/admin-columns";
import { EventConstants } from "AC/constants";
var AcServices = initAcServices();
AcServices.addListener(EventConstants.TABLE.READY, function (e) {
    AcServices.registerService('AddNewInline', new AddNewInline(e.table.Actions));
});
